import { render, staticRenderFns } from "./NeedPostDocs.vue?vue&type=template&id=461950ea&scoped=true&"
import script from "./NeedPostDocs.vue?vue&type=script&lang=js&"
export * from "./NeedPostDocs.vue?vue&type=script&lang=js&"
import style0 from "./NeedPostDocs.vue?vue&type=style&index=0&id=461950ea&prod&lang=css&"
import style1 from "./NeedPostDocs.vue?vue&type=style&index=1&id=461950ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461950ea",
  null
  
)

export default component.exports